import styles from './DashboardIcons.module.css';

function IconBase({ children }: { children: React.ReactNode }): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {children}
    </svg>
  );
}

export function DashboardNavIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path fill="currentColor" d="M4 4h7v7H4V4Zm9 0h7v4h-7V4ZM4 13h7v7H4v-7Zm9 3h7v7h-7v-7Z" />
    </IconBase>
  );
}

export function JourneyNavIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z"
      />
    </IconBase>
  );
}

export function RepaymentsNavIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path fill="currentColor" d="M7 3h10a2 2 0 0 1 2 2v14l-7-3.5L5 19V5a2 2 0 0 1 2-2Z" />
    </IconBase>
  );
}

export function PaymentsNavIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-11Zm1.5 0v11h11v-11h-11Zm2 8.5h7v-2h-7v2Z"
      />
    </IconBase>
  );
}

export function ProfileNavIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path fill="currentColor" d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 9a7 7 0 0 1 14 0H5Z" />
    </IconBase>
  );
}

export function PlanStatusIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path fill="currentColor" d="M5 4h14v2H5V4Zm0 5h14v2H5V9Zm0 5h10v2H5v-2Z" />
    </IconBase>
  );
}

export function DirectDebitIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M12 2 4 6v6c0 5 3.4 8.7 8 10 4.6-1.3 8-5 8-10V6l-8-4Zm0 2.2 6 3v5.8c0 3.8-2.5 6.8-6 7.9-3.5-1.1-6-4.1-6-7.9V7.2l6-3Z"
      />
    </IconBase>
  );
}

export function NextPaymentIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V3a1 1 0 0 1 1-1Zm13 8H4v8h16v-8ZM8 13h2v2H8v-2Z"
      />
    </IconBase>
  );
}

export function TotalPaidIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M12 2C7.6 2 4 5.6 4 10s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm-.5 4h1v4.2l3.1 1.8-.5.9-3.6-2.1V6Z"
      />
    </IconBase>
  );
}

export function OutstandingIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5v5.6l3.5 2-.5.9-4-2.3V7h1Z"
      />
    </IconBase>
  );
}

export function ActionIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M12 2 3 7v2c0 5.2 3.8 10 9 11 5.2-1 9-5.8 9-11V7l-9-5Zm-1 6h2v5h-2V8Zm0 6h2v2h-2v-2Z"
      />
    </IconBase>
  );
}

export function ApplicationsNavIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M6 3h12a2 2 0 0 1 2 2v14l-8-4-8 4V5a2 2 0 0 1 2-2Zm2 4h8v2H8V7Zm0 4h8v2H8v-2Z"
      />
    </IconBase>
  );
}

export function SupportNavIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M12 2a8 8 0 0 0-8 8c0 1.5.4 2.9 1.1 4.1L4 20l5.2-1.4A8 8 0 1 0 12 2Zm0 2a6 6 0 0 1 3.6 10.8l-.4.3-.2.5.3 1.8-1.7-.5-.5.2A6 6 0 0 1 12 4Z"
      />
    </IconBase>
  );
}

export function HeadsetIcon(): React.JSX.Element {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 2a7 7 0 0 0-7 7v4a3 3 0 0 0 3 3h1v-5.5A5.5 5.5 0 0 1 12 3.5 5.5 5.5 0 0 1 17.5 9V16h1a3 3 0 0 0 3-3V9a7 7 0 0 0-7-7Zm-5 12h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2Zm10 0h2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2Z"
      />
    </svg>
  );
}

export function BellIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M12 2a5 5 0 0 0-5 5v2.1c0 .5-.2 1-.5 1.4L5 13.5V15h14v-1.5l-1.5-3.1c-.3-.4-.5-.9-.5-1.4V7a5 5 0 0 0-5-5Zm0 18a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 20Z"
      />
    </IconBase>
  );
}

export function ArrowRightIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M13.2 6.3a1 1 0 0 1 1.4 0l5 5a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.4-1.4L16.6 13H5a1 1 0 1 1 0-2h11.6l-3.4-3.3a1 1 0 0 1 0-1.4Z"
      />
    </IconBase>
  );
}

export function CalendarIcon(): React.JSX.Element {
  return (
    <IconBase>
      <path
        fill="currentColor"
        d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V3a1 1 0 0 1 1-1Z"
      />
    </IconBase>
  );
}

const NAV_ICON_BY_PATH: Record<string, () => React.JSX.Element> = {
  '/app': DashboardNavIcon,
  '/app/customer/timeline': JourneyNavIcon,
  '/app/customer/repayments': RepaymentsNavIcon,
  '/app/customer/payments': PaymentsNavIcon,
  '/app/customer/applications': ApplicationsNavIcon,
  '/app/customer/profile': ProfileNavIcon,
  '/app/admin/applications': ApplicationsNavIcon,
  '/app/admin/customers': ProfileNavIcon,
  '/app/admin/contracts': JourneyNavIcon,
  '/app/admin/mandates': DirectDebitIcon,
  '/app/admin/mandate-cancellations': SupportNavIcon,
  '/app/admin/billing': RepaymentsNavIcon,
  '/app/admin/payment-attempts': ActionIcon,
  '/app/admin/payments': PaymentsNavIcon,
  '/app/admin/reports': PlanStatusIcon,
  '/app/admin/products': DashboardNavIcon,
  '/app/admin/repayment-plans': CalendarIcon,
  '/app/admin/users': ProfileNavIcon,
  '/app/admin/roles': DirectDebitIcon,
  '/app/admin/audit-logs': ApplicationsNavIcon,
  '/app/admin/notifications/outbox': BellIcon,
  '/app/admin/payment-provider/banks': PaymentsNavIcon,
  '/app/admin/system-health': ActionIcon,
};

export function navIconForPath(path: string): React.JSX.Element | null {
  const Icon = NAV_ICON_BY_PATH[path];
  return Icon === undefined ? null : <Icon />;
}
